import React from 'react';

export const Logo = () => {
   return <img src="./brand/logo.svg" width={120} alt="logo" />;
};
